<template>
  <div>
    <div>
      <div
        v-show="mainDressCategoryId == null"
        class="tt"
        style="padding-top: 10px"
      >
        <button
          v-b-modal.add-article-direct-existing-editing
          class="button"
          style="margin-bottom: 10px;"
        >
          {{ $t('AddArticle') }}
        </button>

        <div style="display:flex;gap:10px;align-items: end;margin-bottom: 10px;">
          <div style="display:flex;flex-direction: column;gap:5px">
            <div class="search-toggle">
              <p>{{ $t('SearchBy') }}</p>
              <div>
                <p
                  class="active2"
                >
                  {{ $t('ArticleNumber') }}
                </p>
              </div>
            </div>
            <div>
              <div class="black">
                <b-icon-search
                  v-if="searchArticle == ''"
                  class="search1"
                  style="position: absolute; left: 5px; top: 12px"
                />
                <b-icon-x-circle
                  v-else-if="searchArticle != ''"
                  class="search1"
                  style="position: absolute; right: 20px; top: 12px; cursor: pointer"
                  @click="searchArticle = ''"
                />
                <input
                  v-model="searchArticle"
                  type="text"
                  autocomplete="off"
                  name="search-box"
                  :placeholder="$t('ArticleNumber')"
                  :style="getFilteredDresses.length > 0 ? 'border-radius: 8px 8px 0px 0px' : ''"
                  @keyup="inputChanged"
                  @keydown.down="onArrowDown"
                  @keydown.up="onArrowUp"
                >
              </div>
              <div
                v-if="getFilteredDresses.length > 0"
                ref="scrollContainer"
                class="dropdrop"
                :style="getFilteredDresses.length > 7 ? 'height: 210px' : 'height: auto'"
              >
                <div
                  v-for="(result, index) in getFilteredDresses"
                  :key="index"
                  ref="options"
                  style="cursor: pointer"
                  class="search-item"
                  :class="{ 'is-active': index === arrowCounter }"
                  @click="searchByOnArticles(result);"
                >
                  <p style="margin: 0">
                    {{ result.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <vue-select
            v-model="selectedCategory"
            :options="optionsCategory"
            label="nameFiltering"
            :reduce="(e) => e.lovDressCategoryId"
            :placeholder="$t('Category')"
            aria-describedby="input-1-live-feedback"
            :clearable="false"
            style="width: 30%"
          />
        </div>
        <table
          class="team_table"
        >
          <thead>
            <tr>
              <th>{{ $t('Article') }}</th>
              <th>{{ $t('Category') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in getDresses"
              :key="index"
              v-b-tooltip.hover
              :title="$t('ClickToSeeColor')"
              style="cursor:pointer;"
              @click="updateDresses(item)"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.lovDressCategoryName || $t('NoCategoryFound') }}</td>
            </tr>
          </tbody>
        </table>
        <div>
          <b-pagination
            v-if="getTotalItemsForDresses > 15"
            v-model="pageNumber"
            :total-rows="getTotalItemsForDresses"
            :per-page="pageSize"
            first-number
            last-number
            align="fill"
            size="md"
            prev-class="prev-itemiii"
            next-class="next-itemiii"
            class="mt-1 mb-0"
          >
            <template #prev-text>
              <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
            </template>
            <template #next-text>
              <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
            </template>
          </b-pagination>
        </div>
      </div>
      <div
        v-show="mainDressCategoryId != null && mainDressCategoryColorId == null"
        class="tt"
        style="padding-top: 10px"
      >
        <div style="display:flex;flex-direction:column;gap:15px">
          <b-icon-arrow-left
            style="cursor:pointer; width: 30px; height: 30px;"
            @click="mainDressCategoryId = null"
          />
          <button
            v-b-modal.add-color-direct-existing-editing
            class="button"
            style="margin-bottom: 10px;"
          >
            {{ $t('AddColor') }}
          </button>
        </div>

        <div style="display:flex;gap:10px;align-items: end;margin-bottom: 10px;">
          <div style="display:flex;flex-direction: column;gap:5px">
            <div class="search-toggle">
              <p>{{ $t('SearchBy') }}</p>
              <div>
                <p
                  class="active2"
                >
                  {{ $t('ColorName') }}
                </p>
              </div>
            </div>
            <div>
              <div class="black">
                <b-icon-search
                  v-if="searchColor == ''"
                  class="search1"
                  style="position: absolute; left: 5px; top: 12px"
                />
                <b-icon-x-circle
                  v-else-if="searchColor != ''"
                  class="search1"
                  style="position: absolute; right: 20px; top: 12px; cursor: pointer"
                  @click="searchColor = ''"
                />
                <input
                  v-model="searchColor"
                  type="text"
                  autocomplete="off"
                  name="search-box"
                  :placeholder="$t('ArticleNumber')"
                  :style="getFilteredDressColors.length > 0 ? 'border-radius: 8px 8px 0px 0px' : ''"
                  @keyup="inputChangedColor"
                  @keydown.down="onArrowDownColor"
                  @keydown.up="onArrowUpColor"
                >
              </div>
              <div
                v-if="getFilteredDressColors.length > 0"
                ref="scrollContainer"
                class="dropdrop"
                :style="getFilteredDressColors.length > 7 ? 'height: 210px' : 'height: auto'"
              >
                <div
                  v-for="(result, index) in getFilteredDressColors"
                  :key="index"
                  ref="options"
                  style="cursor: pointer"
                  class="search-item"
                  :class="{ 'is-active': index === arrowCounter }"
                  @click="searchByOnColor(result);"
                >
                  <p style="margin: 0">
                    {{ result }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table
          class="team_table"
        >
          <thead>
            <tr>
              <th>{{ $t('Article') }}</th>
              <th>{{ $t('ColorName') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in getDressColors"
              :key="index"
              v-b-tooltip.hover
              :title="$t('ClickToSeeArticle')"
              style="cursor:pointer;"
              @click="updateDressesColor(item)"
            >
              <td>{{ mainDressCategoryIdName }}</td>
              <td>{{ item.colorName }}</td>
            </tr>
          </tbody>
        </table>
        <div>
          <b-pagination
            v-if="getTotalItemsForDressColors > 15"
            v-model="pageNumber"
            :total-rows="getTotalItemsForDressColors"
            :per-page="pageSize"
            first-number
            last-number
            align="fill"
            size="md"
            prev-class="prev-itemiii"
            next-class="next-itemiii"
            class="mt-1 mb-0"
          >
            <template #prev-text>
              <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
            </template>
            <template #next-text>
              <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
            </template>
          </b-pagination>
        </div>
      </div>
      <div
        v-show="mainDressCategoryColorId !== null"
        class="tt"
        style="padding-top: 10px"
      >
        <div style="display:flex;flex-direction:column;gap:15px">
          <b-icon-arrow-left
            style="cursor:pointer; width: 30px; height: 30px;"
            @click="mainDressCategoryColorId = null"
          />
          <div style="display:flex;gap:10px">

            <button
              v-if="getDressesSize.length !== getSizeTypes.length - 1"
              v-b-modal.add-barcode-direct-existing-editing
              class="button"
              style="margin-bottom: 10px;"
            >
              {{ $t('AddBarcode') }}
            </button>
            <button
              v-b-modal.add-new-barcode-category-editing
              class="button"
              style="margin-bottom: 10px;"
            >
              {{ $t('AddSize') }}
            </button>
          </div>
        </div>

        <table
          class="team_table"
        >
          <thead>
            <tr>
              <th>{{ $t('ArticleNumber') }}</th>
              <th>{{ $t('Barcode') }}</th>
              <th>{{ $t('Size') }}</th>
              <th>{{ $t('SellingPrice') }}</th>
              <th>{{ $t('PurchasePrice') }}</th>
              <th>{{ $t('Description') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in getDressesSize"
              :key="index"
              style="cursor:pointer;"
            >
              <td>{{ item.articleNumber }}</td>
              <td>{{ item.code }}</td>
              <td>{{ item.size }}</td>
              <td>{{ item.price }}</td>
              <td>{{ item.purchasePrice }}</td>
              <td>{{ item.description }}</td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <AddArticleExistingEdit
      @addArticle="addNewArticle"
    />
    <AddNewBarcodeCategoryEdit
      @addSize="addSizes"
    />
    <AddBarcodeExistingEdit
      :main-dress-color-id="mainDressCategoryColorId"
      :main-dress-id="mainDressCategoryId"
      :main-color-article-name="mainDressCategoryIdName"
      :main-dress-category-color-id-name="mainDressCategoryColorIdName"
      @addBarcode="addArticleBarcode"
    />
    <AddColorExistingEdit
      :article-id="mainDressCategoryId"
      :article-name="mainDressCategoryIdName"
      @addColor="addNewColor"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddArticleExistingEdit from './AddArticlesModals/AddArticleExstingEdit.vue';
import AddColorExistingEdit from './AddArticlesModals/AddColorExistingEdit.vue';
import AddBarcodeExistingEdit from './AddArticlesModals/AddBarcodeExistingEdit.vue';
import AddNewBarcodeCategoryEdit from './AddArticlesModals/AddNewBarcodeCategoryEdit.vue';



export default {
  components: {
    AddArticleExistingEdit,
    AddColorExistingEdit,
    AddBarcodeExistingEdit,
    AddNewBarcodeCategoryEdit,
  },
  data() {
    return {
      pageNumber: 1,
      pageSize: 15,
      selectedCategory: null,
      searchArticle: '',
      searchColor: '',
      arrowCounter: 0,
      enterPressed: false,
      skipWatch: false,
      mainDressCategoryId: null,
      mainDressCategoryIdName: null,
      mainDressCategoryColorId: null,
      mainDressCategoryColorIdName: null,
    }
  },
  computed: {
    ...mapGetters(['getDresses', 'getDressesSize', 'getSizeTypes', 'getTotalItemsForDressColors', 'getFilteredDressColors', 'getTotalItemsForDresses', 'getDressCategory', 'getFilteredDresses', 'getDressColors']),
    optionsCategory() {
      const valoniCategory = this.getDressCategory.map((category) => {
        return {
          name: category.name,
          nameFiltering: category.name,
          lovDressCategoryId: category.lovDressCategoryId,
        }
      });
      const nullCategory = {
        name: null,
        nameFiltering: 'All',
        lovDressCategoryId: null,
      }
      const combinedCategories = [nullCategory, ...valoniCategory];

      return combinedCategories;
    },
  },
  watch: {
    pageNumber(value) {
      if (value) {
        this.loadDressesPagination({
          pageNumber: value,
          pageSize: this.pageSize,
          mdcName: null,
          dressCategoryId: this.selectedCategory,
        })
      }
    },
    selectedCategory(value) {
      this.loadDressesPagination({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        mdcName: this.searchArticle,
        dressCategoryId: value,
      })
    },
    searchArticle(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeListsArticles();
        } else if (!this.enterPressed) {
          this.filteredDressesByName({
            code: null,
            name: value,
          });
        }
      }, 500);
    },
    searchColor(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeListsColor();
        } else if (!this.enterPressed) {
          this.filteredDressColorsByName({
            mainDressCategoryId: this.mainDressCategoryId,
            name: value,
          });
        }
      }, 500);
    },
  },
  mounted() {
    this.loadDressesPagination({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      mdcName: null,
      dressCategoryId: null,
    })
    this.dressCategories()
    this.productSizes()
  },
  methods: {
    ...mapActions(['loadDressesPagination', 'addProductLovSize', 'productSizes', 'loadSizeTypes', 'addInventoryProductSize', 'addColorToMainDressCategoryById', 'addMainDressCategory', 'inventoryProductSizeFromColorId', 'resetFilteredDressColors', 'filteredDressColorsByName', 'loadDressColorsById', 'resetFilteredDresses', 'filteredDressesByName', 'dressCategories']),
    async addSizes(obj) {
      await this.addProductLovSize({
        object: obj,
        successCallback: () => {
          this.productSizes()
        },
      })
    },
    addArticleBarcode(object) {
      this.addInventoryProductSize({
        object,
        successCallback: () => {
          this.inventoryProductSizeFromColorId(this.mainDressCategoryColorId)
        },
      });
    },
    addNewColor(obj) {
      this.addColorToMainDressCategoryById({
        object: obj,
        successCallback: () => {
          this.loadDressColorsById({
            mainDressCategoryId: this.mainDressCategoryId,
            pageNumber: 1,
            pageSize: this.pageSize,
          })
        },
      });
    },
    addNewArticle(obj) {
      this.addMainDressCategory({
        object: obj,
        successCallback: () => {
          this.loadDressesPagination({
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
            mdcName: this.searchArticle,
            dressCategoryId: this.selectedCategory,
          })
        },
      });
    },
    updateDressesColor(value) {
      this.inventoryProductSizeFromColorId(value.mainDressCategoryColorId)
        .then(() => {
          this.mainDressCategoryColorId = value.mainDressCategoryColorId
          this.mainDressCategoryColorIdName = value.colorName
          this.pageNumber = 1
        })
    },
    updateDresses(value) {
      this.loadDressColorsById({
        mainDressCategoryId: value.id,
        pageNumber: 1,
        pageSize: this.pageSize,
      }).then(() => {
        this.mainDressCategoryId = value.id
        this.mainDressCategoryIdName = value.name
        this.pageNumber = 1
      })
    },
    async searchByOnArticles(value) {
      this.skipWatch = true;
      this.searchArticle = value.name;
      this.loadDressesPagination({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        mdcName: value.name,
        dressCategoryId: null,
      })
      this.resetFilteredDresses()
    },
    async searchByOnColor(value) {
      this.skipWatch = true;
      this.searchColor = value;
      this.loadDressColorsById({
        mainDressCategoryId: this.mainDressCategoryId,
        name: value,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
      this.resetFilteredDressColors()
    },
    inputChangedColor(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }
      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByOnColor(this.getFilteredDressColors[this.arrowCounter])
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    onArrowDownColor(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getFilteredDressColors.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUpColor(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    removeListsColor() {
      this.loadDressColorsById({
        mainDressCategoryId: this.mainDressCategoryId,
        name: null,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
      this.resetFilteredDressColors()
    },
    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }
      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByOnArticles(this.getFilteredDresses[this.arrowCounter])
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    onArrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getFilteredDresses.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    removeListsArticles() {
      this.loadDressesPagination({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        mdcName: null,
        dressCategoryId: this.selectedCategory,
      })
      this.resetFilteredDresses()
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      console.log(liH)
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
    },
  },
}
</script>

  <style lang="scss" scoped>
  .team_table td {
    padding: 16px 9px !important;
  }
  .active2{
      color: #212529;
      font-weight: bold;
    }
    .dropdrop {
      display: inline-block;
      overflow: auto;
      position: absolute;
      background: white;
      width: 227px;
      box-shadow: none;
      z-index:3;
    }

    input[name="search-box"] {
      display: block;
      max-width: 500px;
      width: 95%;
      padding: 0.5rem 1rem;
      padding-left: 25px;
    }

    .search-item {
      padding: 5px;
      max-width: 500px;
      width: 100%;
      font-weight: 400;
      color: #82868c;
      font-size: 1rem;
      border-bottom: 1px solid #e8e8e8;
    }

  </style>
